<template>
    <f7-page>
        <sac-c-kodinpro-navbar slot="fixed" enable-right-menu />
        <sac-c-kodinpro-websitenavbar v-if="$store.state.isBrowser" />
        <sac-c-kodinpro-customertabs slot="fixed" />
        <sac-c-kodinpro-webtabnav slot="fixed" customer />
        <sac-c-kodinpro-homepage />

    </f7-page>

</template>

<script>


export default {


    data() {
        return {


        };
    },
    mounted() {


    },
    methods: {

    }

};
</script>
<style scoped>

</style>
